<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Arkman {{  $t('XML-Export') }} </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>

            </v-toolbar>
          </v-flex>




          <v-container fluid="">
            <v-card flat>
              <v-form ref="formcariyegore" v-model="valid" lazy-validation>

                <v-layout row wrap="">

                  <v-flex pl-2 xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" v-bind:defaultvalue="'ok'"
                      v-bind:value="xmlInput.BaslangicTarih" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-model="xmlInput.BaslangicTarih"></tarihcomp>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Finishing-Date')" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="xmlInput.BitisTarih" v-model="xmlInput.BitisTarih">
                    </tarihcomp>
                  </v-flex>

                  <v-flex xs12 sm12 md3>

                   <cariaracomp v-bind:etiket="$t('Current-Account')" v-bind:value="xmlInput.CariKod" :loading="loading" v-bind:zorunlumu="true"
                                  v-model="xmlInput.CariKod"></cariaracomp>
                  </v-flex>

                  <v-flex xs12 sm2 md2>
                    <v-layout row wrap align-center fill-height>
                    <v-btn outline block @click="getList()" flat color="info"><v-icon >get_app</v-icon> &nbsp; XML {{ $t('Download-File') }}</v-btn>
                    <v-btn   @click.native="(filterDialog = true)" fab ref="fab" small  color="info"><v-icon >filter_list</v-icon></v-btn>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-form>
              <v-layout>


              </v-layout>
            </v-card>
          </v-container>

          
          <v-layout row justify-center>
                <v-dialog v-model="filterDialog" persistent max-width="350">
                    <v-card>
                        <v-card-title class="headline">Filtre Seçimi</v-card-title>
                        <v-card-text>
                                   <v-checkbox label="Servis Ücretini Bilete Dahil Et" v-model="xmlInput.ServisBedel"></v-checkbox>      
                                   <v-checkbox label="Rezerv Ücretini Bilete Dahil Et" v-model="xmlInput.RezervBedel"></v-checkbox>                      
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" flat @click.native="filterDialog = false"> {{ $t('cancel_button') }} </v-btn>
                            <v-btn color="primary" flat @click="getList()">{{ $t('Apply') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'

  export default {
    data() {
      return {
        filterDialog:false,
        loadingvmodel: false,
        xmlsonuc: true,
        xmlInput: {
          MusteriKod: null,
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          CariKod: null,
          ServisBedel:false,
          RezervBedel:false,
        },
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        search: '',
        dovizToplamlar: [],
        headerstl: [{
            text: this.$t('Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkod'
          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'Vade'
          },
          {
            text: this.$t('Debit'),
            value: 'Borc',
            align: 'right'

          }, {
            text: this.$t('Credit'),
            value: 'Alacak',
            align: 'right'
          },

          {
            text: this.$t('Balance'),
            value: 'Bakiye',
            align: 'right'

          }
        ],
        headersdoviz: [{
            text: this.$t('Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkod'
          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'Vade'
          },
          {
            text: this.$t('Currency'),
            value: 'Doviz.DovizKod',
          },
          {
            text: this.$t('Debit'),
            value: 'Borc',
            align: 'right'

          }, {
            text: this.$t('Credit'),
            value: 'Alacak',
            align: 'right'
          }
        ],
        headerstldoviz: [{
            text: this.$t('Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkod'
          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'Vade'
          }, {
            text: this.$t('Amount'),
            value: 'Tutar',
            align: 'right'
          },
          {
            text: 'BA',
            value: 'BA',
          },
          {
            text: this.$t('Currency'),
            value: 'Doviz.DovizKod',
          },
          {
            text: this.$t('Debit'),
            value: 'Borc',
            align: 'right'

          }, {
            text: this.$t('Credit'),
            value: 'Alacak',
            align: 'right'
          }
        ],
        EkstreHesap: {

          SirketKodu: null,
          Cari: {
            Kod: null
          },
          BaslangicTarih: null,
          BitisTarih: null,
          IstenilenReferanslar: [],
          IstenmeyenReferanslar: [],
          Masraflar: [],
          Gruplar: [],
          NoGruplar: [],
          Evraklar: [],
          Tarihler: 0, // 0 : Tarih,  1 : Vade , 2 : Fatura Tarihi
          RaporTip: false, // false : Detay, true : Ozet
          RaporDvzTip: 0, // 0 : tl, 1 : dvz, 2 : tl+dvz
          BsYolcuDetay: false,
          SifirTutar: false,
          DevirGoster: false,
          AltHesapGosterme: false,
          TlAta: false,
          CoperKayit: false,
          ProgramTip: 0 //0 : Hepsi,1 : Sadece Coper, 2 : Coper Hariç
        },
        devirborc: 0,
        deviralacak: 0,
        devirbakiye: 0,
        donemborc: 0,
        donemalacak: 0,
        donembakiye: 0,
        toplamborc: 0,
        toplamalacak: 0,
        toplambakiye: 0,
        valid: true,

        statecari: [],
        searchcari: '',
        Carihesap: '',
        text1: null,
        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],
        tumsirketler: false,
        anahesap: [],
        hesapgurubu: [],
        evraktipi: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog,
      loadingcomp,
      snackbarcomp,
      cariaracomp
    },
    mounted() {
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });
      }else{
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.loadingvmodel = true;
        var params = {
          CompanyCode: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.loadingvmodel = false;
          this.xmlInput.ServisBedel = response.body.GenelParametre.ParametreCari.BiletTutariServisli;
          this.xmlInput.RezervBedel = response.body.GenelParametre.ParametreCari.BiletTutariDegiskenli;

        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.loadingvmodel = false;
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.loadingvmodel = false;
          }
        })
      }


    },
    watch: {
      'EkstreHesap.RaporDvzTip': function (a) {

        if (a == 1 || a == 2) {
          this.EkstreHesap.RaporTip = false
        }

        if (a == 0) {
          this.headers = this.headerstl
        } else if (a == 1) {
          this.headers = this.headersdoviz
        } else if (a == 2) {
          this.headers = this.headerstldoviz
        }
      },
      'EkstreHesap.RaporTip': function (a) {
        if (a == false) {
          this.EkstreHesap.RaporDvzTip = 0
        } else if (a == true) {
          if (this.EkstreHesap.RaporDvzTip == 1 || this.EkstreHesap.RaporDvzTip == 2) {
            this.EkstreHesap.RaporDvzTip = 0
          }
        }
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {


      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      getDownload
    }
  }

  function getList() {

    var bastarih = new Date(this.xmlInput.BaslangicTarih)
    var bittarih = new Date(this.xmlInput.BitisTarih)

    if (bastarih <= bittarih) {
      
      if (this.$refs.formcariyegore.validate()) {
        this.filterDialog = false;
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.loadingvmodel = true

        this.xmlInput.MusteriKod = credentials.AnaSirketKodu
        this.xmlInput.SirketKodu = credentials.SirketKodu
        var params = this.xmlInput

        this.load1 = false

        this.$http.post(auth.API_URL + 'api/TicketStream/ArkmanXmlExport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.loadingvmodel = false
          this.load1 = true

          if (response.body.Status == true) {

            this.getDownload();

          } else {
             this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true;
            this.loadingvmodel = false;
            this.load1 = true;
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.xmlsonuc = false
            this.load1 = true
            this.loadingvmodel = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.xmlsonuc = false
            this.load1 = true
            this.loadingvmodel = false
          }
        })

      }

    } else {

      this.load1 = true

      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true

    }



  }

  function getDownload() {



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.loadingvmodel = true

    this.xmlInput.MusteriKod = credentials.AnaSirketKodu
    this.xmlInput.SirketKodu = credentials.SirketKodu
    var params = this.xmlInput





    this.$http.post(auth.API_URL + 'api/TicketStream/GetArkmanXmlFileZip', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
      },
       responseType: 'blob'
    }).then((response) => {

          var blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "ArkmanXmlExport.zip";
          link.click();

      this.loadingvmodel = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.xmlsonuc = false
        this.load1 = true
        this.loadingvmodel = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.xmlsonuc = false
        this.load1 = true
        this.loadingvmodel = false
      }
    })


  }

  function getListHtml() {

    if (this.$refs.formcariyegore.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }
      this.progress = true


      var yenidizi = []

      this.EkstreHesap.IstenilenReferanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.IstenilenReferanslar = yenidizi;

      yenidizi = [];

      this.EkstreHesap.IstenmeyenReferanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.IstenmeyenReferanslar = yenidizi;

      yenidizi = [];


      this.EkstreHesap.Masraflar.forEach(element => {
        var kayit = {
          Code: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.Masraflar = yenidizi;
      yenidizi = [];


      this.EkstreHesap.Evraklar.forEach(element => {
        var kayit = {
          Evrakkod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.Evraklar = yenidizi;
      yenidizi = [];

      var params = this.EkstreHesap
      this.load1 = false

      this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetailHtml', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "HesapEkstre.html";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

    }



  }

  function getListExcel() {
    if (this.$refs.formcariyegore.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }
      this.progress = true


      var yenidizi = []

      this.EkstreHesap.IstenilenReferanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.IstenilenReferanslar = yenidizi;

      yenidizi = [];

      this.EkstreHesap.IstenmeyenReferanslar.forEach(element => {
        var kayit = {
          Kod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.IstenmeyenReferanslar = yenidizi;

      yenidizi = [];


      this.EkstreHesap.Masraflar.forEach(element => {
        var kayit = {
          Code: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.Masraflar = yenidizi;
      yenidizi = [];


      this.EkstreHesap.Evraklar.forEach(element => {
        var kayit = {
          Evrakkod: element
        }
        yenidizi.push(kayit)
      });
      this.EkstreHesap.Evraklar = yenidizi;
      yenidizi = [];

      var params = this.EkstreHesap
      this.load1 = false

      this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetailExcel', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "HesapEkstre.xlsx";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

    }

  }

  function beforeMount() {
    this.headers = this.headerstl
  }
</script>

<style>

</style>